module.exports = Object.assign;
